import { render, staticRenderFns } from "./ProductSloganPopupIframe.vue?vue&type=template&id=b9f47ee0&"
import script from "./ProductSloganPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductSloganPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports